import React, { useEffect, useState } from 'react';
import Link from 'next/link'
import type { NextPage } from 'next';
import styles from './index.module.scss';
import cName from "classnames";
import Wrapper from '@/components/wrapper';
import * as echarts from 'echarts';
import TicketModal from '@/components/ticket-modal';
import { getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export { getServerSideProps }

const Why: NextPage<IProps> = ({ menuDetail }: any) => {
  const router = useRouter();
  const t = useTranslations("exhibition.why");
  const [isShowTicketModal, setIsShowTicketModal] = useState(false)

  const audiPieOption = {
    title: {
      text: t('section2.chart1.title'),
      subtext: t('section2.chart1.subtext'),
      x: 'center',
      y: '175',
      itemGap: 0,
      textStyle: {
        fontFamily: '微软雅黑',
        fontSize: 28,
        fontWeight: 'bolder',
      },
      subtextStyle: {
        color: 'eee',
        fontSize: 28,
        fontWeight: 'bolder',
      }
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['55%', '80%'],
        animationDuration: 2500,
        startAngle: 80,
        data: [
          {
            value: t('section2.chart1.item1num'), name: t('section2.chart1.item1tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f3af4a' },
                  { offset: 1, color: '#f8f3bd' }
                ]
              )
            }
          },
          {
            value: t('section2.chart1.item2num'), name: t('section2.chart1.item2tit'), itemStyle: {
              color: '#f5c352'
            }
          },
          { value: t('section2.chart1.item3num'), name: t('section2.chart1.item3tit'), itemStyle: { color: '#c9741c' } },
          { value: t('section2.chart1.item4num'), name: t('section2.chart1.item4tit'), itemStyle: { color: '#e36819' } },
          { value: t('section2.chart1.item5num'), name: t('section2.chart1.item5tit'), itemStyle: { color: '#f18c1b' } },
          {
            value: t('section2.chart1.item6num'), name: t('section2.chart1.item6tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f6dc59' },
                  { offset: 1, color: '#f8f2bd' }
                ]
              )
            }
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          // show: false
          normal: {
            length: 30
          }
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return '{a|' + params.value + '%}' + '\n' + '{b|' + params.name + '}';
          },
          offset: [0, 0],
          overflow: 'none',
          rich: {
            a: {
              color: '#fcb814',
              fontSize: '24px',
              lineHeight: 30,
              fontWeight: 'bold',
              align: 'left'
            },
            b: {
              color: '#666',
              fontSize: '14px',
              fontWeight: 'normal',
              align: 'center'
            }
          },
        },

      }
    ]
  }
  const audiBarOption = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params: any) {
        // 假设 params.seriesName 是实际数据的系列名
        if (params[0].seriesName == 'data') {
          // 只返回实际数据的值
          return (
            params[0].name +
            '<br/>' +
            params[0].seriesName +
            ': ' +
            params[0].value +
            '%'
          );
        }
        // 对于剩余部分的数据，不返回任何内容，这样 tooltip 就不会显示
        return '';
      }
    },
    legend: {
      data: ['柱状图1', '柱状图2']
    },
    xAxis: [
      {
        type: 'value',
        boundaryGap: [0],
        position: 'top',
        data: ['总量'],
        max: 100,
        // scale: 0.8,
        axisLine: {
          show: false // 是否显示坐标轴线
        },
        axisTick: {
          // 控制刻度
          show: false // 不显示刻度
        },
        axisLabel: {
          // 控制坐标轴标签
          show: false // 不显示坐标轴标签
        },
        splitLine: {
          // 控制网格线
          show: false // 不显示网格线
        }
      }
    ],
    yAxis: [
      {
        type: 'category',
        max: 9,
        data: [
          t('section2.chart2.item1tit'),
          t('section2.chart2.item2tit'),
          t('section2.chart2.item3tit'),
          t('section2.chart2.item4tit'),
          t('section2.chart2.item5tit'),
          t('section2.chart2.item6tit'),
          t('section2.chart2.item7tit'),
          t('section2.chart2.item8tit'),
          t('section2.chart2.item9tit'),
          t('section2.chart2.item10tit'),
        ],
        axisLabel: {
          fontSize: '14px',
          lineHeight: 20,
          align: 'right',
          margin: 10,
          color: '#666'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#f5f5f5'
          }
        }
      }
    ],
    series: [
      {
        name: 'data',
        type: 'bar',
        // barGap: ,
        barGap: '-100%',
        barCategoryGap: '60%',
        animationDuration: 2500,
        // stack: '总量',
        itemStyle: {
          color: '#fcb814',
          barBorderRadius: 20
        },
        z: 10,
        data: [
          t('section2.chart2.item1num'),
          t('section2.chart2.item2num'),
          t('section2.chart2.item3num'),
          t('section2.chart2.item4num'),
          t('section2.chart2.item5num'),
          t('section2.chart2.item6num'),
          t('section2.chart2.item7num'),
          t('section2.chart2.item8num'),
          t('section2.chart2.item9num'),
          t('section2.chart2.item10num'),
        ]
      },
      {
        name: '剩余部分',
        type: 'bar',
        // stack: '总量',
        label: {
          show: true,
          position: 'right',
          formatter: function (params: any,) {
            const data = [
              t('section2.chart2.item1num'),
              t('section2.chart2.item2num'),
              t('section2.chart2.item3num'),
              t('section2.chart2.item4num'),
              t('section2.chart2.item5num'),
              t('section2.chart2.item6num'),
              t('section2.chart2.item7num'),
              t('section2.chart2.item8num'),
              t('section2.chart2.item9num'),
              t('section2.chart2.item10num'),
            ]
            var percent = data[params.dataIndex] + '%'; // 计算并格式化占比
            return '{a|' + percent + '}';
          },
          rich: {
            a: {
              fontSize: 16,
              color: '#333',
              fontFamily: '微软雅黑',
              fontWeight: '500'
            }
          },
          // padding: [4, 8, 1]
        },
        itemStyle: {
          color: '#fee3a1',
          barBorderRadius: 20,
        },
        data: (function () {
          return Array(10).fill(100);
        })()
      }
    ],
    grid: {
      top: '0',
      left: '0',
      right: '65',
      bottom: '0',
      containLabel: true
    }
  }

  useEffect(() => {
    const audiPie = echarts.init(document.getElementById('audiPie'))
    audiPie.setOption(audiPieOption)
    const audiBar = echarts.init(document.getElementById('audiBar'))
    audiBar.setOption(audiBarOption)
  }, [])

  return (
    <div>
      <Wrapper>
        <div className={cName([styles.container])}>
          {getHead(menuDetail)}
          <div className={cName([styles.reason, 'm-1600'])}>
            <h2>{t('section1.title')}</h2>
            <p className={styles.text}>{t('section1.text')}</p>
            <ul>
              <li>
                <img src="https://img.cbcechina.com/2024-11-11/c3688a812349d0b45b672f69b3df2725.png" alt="" />
                <h3>{t('section1.item1tit')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('section1.item1txt') }}></p>
              </li>
              <li>
                <img src="https://img.cbcechina.com/2025-07-18/0409f01b3b008f17f476d3b2f0364e94.jpg" alt="" />
                <h3>{t('section1.item2tit')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('section1.item2txt') }}></p>
              </li>
              <li>
                <img src="https://img.cbcechina.com/2025-07-18/74b2f905327357cbe61abcf845a62bf6.jpg" alt="" />
                <h3>{t('section1.item3tit')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('section1.item3txt') }}></p>
              </li>
            </ul>
            <div className={cName([styles.btns])}>
              <Link href="/exhibition/apply">
                <a>
                  <div className={cName([styles.register, 'btnStyle'])}>
                    <span>{t('section1.btn1')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#ffffff">
                      </path>
                    </svg>
                  </div>
                </a>
              </Link>
              <Link href="https://cbce2025.gration.cn/?member/register&code=sites">
                <a target="_blank">
                  <div className={cName([styles.order, 'btnStyle'])}>
                    <span>{t('section1.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#FCB814">
                      </path>
                    </svg>
                  </div>
                </a>
              </Link>
            </div>
          </div>
          <img className={styles.banner} src="https://img.cbcechina.com/2025-07-18/1e22118f3e0859722d25848a55b8bd83.png" alt="" />
          <div className={cName([styles.aboutAudi, 'm-1600'])}>
            <h2>{t('section2.title')}</h2>
            <div className={styles.data}>
              <div id='audiPie' className={styles.pie} />
              <div className={styles.bar}>
                <h4>{t('section2.chart2.title')}</h4>
                <div id='audiBar' className={styles.audiBar} />
              </div>
              <div className={styles.right}>
                <h4>{t('section2.chart3.title')}</h4>
                <div>
                  <img src="/image/lookback-data.png?v=2025" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className={cName([styles.meeting, 'm-1600'])}>
            <div>
              <h2>{t('section3.title')}</h2>
              <div>
                <p dangerouslySetInnerHTML={{ __html: t('section3.text') }}></p>
                <div className={styles.btns}>
                  <Link href="/summit/2025">
                    <a>
                      <div className={cName([styles.more, 'btnStyle'])}>
                        <span>{t('section3.btn1')}</span>
                        {/* @ts-ignore */}
                        <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                          <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                          </path>
                        </svg>
                      </div>
                    </a>
                  </Link>
                  <div className={cName([styles.buy, 'btnStyle'])} onClick={() => setIsShowTicketModal(true)}>
                    <span>{t('section3.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673">
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cName([styles.forum, 'm-1600'])}>
            <div>
              <h2>{t('section4.title')}</h2>
              <div>
                <p dangerouslySetInnerHTML={{ __html: t('section4.text') }}></p>
                <div className={styles.btns}>
                  <Link href="/summit/2025">
                    <a>
                      <div className={cName([styles.more, 'btnStyle'])}>
                        <span>{t('section4.btn1')}</span>
                        {/* @ts-ignore */}
                        <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                          <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                          </path>
                        </svg>
                      </div>
                    </a>
                  </Link>
                  <div className={cName([styles.buy, 'btnStyle'])} onClick={() => setIsShowTicketModal(true)}>
                    <span>{t('section4.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673">
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TicketModal visible={isShowTicketModal} onCancel={() => setIsShowTicketModal(false)}></TicketModal>
        </div>
      </Wrapper>
    </div>
  );
};

export default Why;
